import { Component, Input, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { toBoolean } from '../util/util';
var NglSpinner = (function () {
    function NglSpinner() {
        this.size = 'medium';
        this._container = false;
    }
    Object.defineProperty(NglSpinner.prototype, "hasContainer", {
        get: function () {
            return this._container;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NglSpinner.prototype, "container", {
        set: function (container) {
            this._container = toBoolean(container);
        },
        enumerable: true,
        configurable: true
    });
    NglSpinner.decorators = [
        { type: Component, args: [{
                    selector: 'ngl-spinner',
                    template: "\n    <div class=\"slds-spinner\" [ngClass]=\"['slds-spinner--' + size, type ? 'slds-spinner--' + type : '']\" aria-hidden=\"false\" role=\"alert\"><div class=\"slds-spinner__dot-a\"></div><div class=\"slds-spinner__dot-b\"></div></div>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                },] },
    ];
    /** @nocollapse */
    NglSpinner.ctorParameters = function () { return []; };
    NglSpinner.propDecorators = {
        'size': [{ type: Input },],
        'type': [{ type: Input },],
        'hasContainer': [{ type: HostBinding, args: ['class.slds-spinner_container',] },],
        'container': [{ type: Input },],
    };
    return NglSpinner;
}());
export { NglSpinner };
;
//# sourceMappingURL=spinner.js.map